 export const GlobalVariable = Object.freeze({
     _API_URL_: 'http://app.araner.com/api/',
     _URL_: 'http://app.araner.com/',
 });
